module.exports = __webpack_public_path__ + "static/media/product-4.6b384894.png";